'use client';

import { PropsWithChildren } from 'react';
import { When } from 'react-if';
import { withAsyncBoundary } from '@toss/async-boundary';
import { PlusIcon } from '@zep-us/zus-icons';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { Button, Table, TableSkeleton } from '@zep/ui';
import { Error500PageView } from '@zep/web-components';
import { useMyApps, ZepApp, ZepAppType } from '../../../../../../services';
import { MyAppWrapper } from '../components';
import S from './MyAppList.module.scss';
export const MyAppList = () => {
  return <MyAppWrapper data-sentry-element="MyAppWrapper" data-sentry-component="MyAppList" data-sentry-source-file="MyAppList.tsx">
      <Container data-sentry-element="Container" data-sentry-source-file="MyAppList.tsx">
        <Header data-sentry-element="Header" data-sentry-source-file="MyAppList.tsx" />
        <Content data-sentry-element="Content" data-sentry-source-file="MyAppList.tsx" />
      </Container>
    </MyAppWrapper>;
};
const ContentTable = () => {
  const {
    data
  } = useMyApps({
    suspense: true
  });
  const {
    apps
  } = data!;
  const router = useRouter();
  const {
    t
  } = useTranslation(['accounts']);
  const goDetailPage = (app: ZepApp) => {
    void router.push(`/me/apps/${app.hashId}`);
  };
  return <>
      <Table onRowClick={goDetailPage} columns={[{
      title: 'ID',
      dataIndex: 'id',
      render: ({
        id
      }) => {
        return <Text>{id}</Text>;
      }
    }, {
      title: t('accounts:myApp.list.type'),
      dataIndex: 'type',
      render: ({
        type
      }) => {
        const text = {
          [ZepAppType.Normal]: t('accounts:myApp.upload.normalApp'),
          [ZepAppType.Sidebar]: t('accounts:myApp.upload.sidebar'),
          [ZepAppType.MiniGame]: t('accounts:myApp.upload.miniGame')
        };
        return <Text>{text[type]}</Text>;
      }
    }, {
      title: t('accounts:myApp.list.name'),
      dataIndex: 'name',
      render: ({
        name
      }) => {
        return <Text>{name}</Text>;
      }
    }]} data={apps} data-sentry-element="Table" data-sentry-source-file="MyAppList.tsx" />
      <When condition={apps.length === 0} data-sentry-element="When" data-sentry-source-file="MyAppList.tsx">
        <EmptyApps data-sentry-element="EmptyApps" data-sentry-source-file="MyAppList.tsx" />
      </When>
    </>;
};
const Content = withAsyncBoundary(ContentTable, {
  pendingFallback: <TableSkeleton />,
  rejectedFallback: () => {
    return <Error500PageView />;
  },
  onError: error => {
    console.error(error);
  }
});
const Header = () => {
  const router = useRouter();
  const {
    t
  } = useTranslation(['accounts']);
  const goUploadApp = () => {
    void router.push('/me/apps/upload');
  };
  return <div className={S.header} data-sentry-component="Header" data-sentry-source-file="MyAppList.tsx">
      <span className={S.title}>{t('accounts:myApp.list.myApp')}</span>
      <Button onClick={goUploadApp} leftSlot={<PlusIcon width={18} height={19} fill="#FFF" />} size={'sm'} data-sentry-element="Button" data-sentry-source-file="MyAppList.tsx">
        {t('accounts:myApp.common.uploadApp')}
      </Button>
    </div>;
};
const EmptyApps = () => {
  const {
    t
  } = useTranslation(['accounts']);
  return <div className={S.empty_wrapper} data-sentry-component="EmptyApps" data-sentry-source-file="MyAppList.tsx">
      <img src="/images/my-apps-empty.png" alt="empty-apps-icon" />
      <span> {t('accounts:myApp.list.empty')}</span>
    </div>;
};
const Text = (props: PropsWithChildren) => {
  return <div className={S.row_text} data-sentry-component="Text" data-sentry-source-file="MyAppList.tsx">{props.children}</div>;
};
const Container = (props: PropsWithChildren) => {
  return <section className={S.wrapper} data-sentry-component="Container" data-sentry-source-file="MyAppList.tsx">{props.children}</section>;
};